import PropTypes from 'prop-types';

import Snackbar from '@zenbusiness/zui/Snackbar';
import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

const AUTO_DISMISS = 5000;

export default function Notification({ disposeOrphan, duration = AUTO_DISMISS, ...props }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const anchorOrigin = isMobile
    ? { vertical: 'top', horizontal: 'center' }
    : { vertical: 'bottom', horizontal: 'right' };

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      autoHideDuration={duration}
      open
      sx={{ maxWidth: 400 }}
      onClose={disposeOrphan}
      {...props}
    />
  );
}
Notification.propTypes = {
  ...Snackbar.propTypes,
  disposeOrphan: PropTypes.func,
  duration: PropTypes.number
};
